// Side-effect import — MUST come before App / CS3D imports. The module
// wraps console at module-eval time to suppress dcmjs's per-tag "Invalid
// vr type" chatter that would otherwise flood the console during CS3D
// module bootstrap (dcmjs is a transitive dep of dicom-image-loader).
import './utils/silenceConsoleNoise';
import ReactDOM from 'react-dom/client';

// Loud boot banner — makes it obvious which build is loaded when we're
// iterating fast. Read `__APP_VERSION__` (injected by vite.config define).
declare const __APP_VERSION__: string;
// eslint-disable-next-line no-console
console.log(
  `%c EdgeWeb v${__APP_VERSION__} %c`,
  'background:#29548c;color:#fff;font-weight:bold;padding:2px 8px;border-radius:3px',
  ''
);
import { HashRouter } from 'react-router-dom';
import { registerLicense } from '@syncfusion/ej2-base';
import App from './App';
// Plugins self-register at module load. Import as a side-effect before
// components that read from the plugin registry (Toolbar) get mounted.
import './plugins';
import './styles/global.css';
import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-lists/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-splitbuttons/styles/material.css';
import '@syncfusion/ej2-dropdowns/styles/material.css';
import '@syncfusion/ej2-react-documenteditor/styles/material.css';

// Syncfusion Community licence — DOCX Editor Developer SDK platform (v33.x)
// (valid while team ≤ 5 devs AND revenue ≤ $1M/year)
registerLicense(
  'NxYtGyMROh0gHDMgDk1jX09FaFtGVmJLYVB3WmpQdldgdVRMZVVbQX9PIiBoS35RcEVnWHded3ZTQ2RaUUN1VEFe'
);

// HashRouter uses /#/worklist instead of /worklist — works with any
// static file server (nginx, Caddy, IIS, …) without URL rewrite rules.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <HashRouter>
    <App />
  </HashRouter>
);
